import { CheckboxDemos } from '@demos/core';
import { CHECKBOX_SIZES } from '@mantine/core';
import * as React from 'react';
export default {
  CheckboxDemos,
  CHECKBOX_SIZES,
  React
};